import { render, staticRenderFns } from "./dataManage.vue?vue&type=template&id=21097ebe&scoped=true&"
import script from "./dataManage.vue?vue&type=script&lang=js&"
export * from "./dataManage.vue?vue&type=script&lang=js&"
import style0 from "./dataManage.vue?vue&type=style&index=0&id=21097ebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21097ebe",
  null
  
)

export default component.exports